import { Card, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { RegisteredStudentData } from "../AdminSingleEventPage";
import { StudyProgramsChart } from "./Charts";
import { StyledHr } from "./style";

const { Text } = Typography;

interface Props {
  registeredStudents: RegisteredStudentData[];
}

export interface StudyProgramDistributionData {
  studyProgram: string;
  amount: number;
}

const StudyProgramDistribution: React.FC<Props> = ({ registeredStudents }) => {
  const [studyProgramDistribution, setStudyProgramDistribution] = useState<StudyProgramDistributionData[]>([]);

  useEffect(() => {
    const distributionData: StudyProgramDistributionData[] = Object.entries(
      registeredStudents.reduce((acc, student) => {
        acc[student.study_programme_name] = (acc[student.study_programme_name] || 0) + 1;
        return acc;
      }, {} as Record<string, number>)
    ).map(([studyProgram, amount]) => ({ studyProgram, amount }));

    setStudyProgramDistribution(distributionData);
  }, [registeredStudents]);

  return (
    <>
      <Card title="Påmeldte fordelt på studielinje" style={{ height: "100%" }}>
        <StudyProgramsChart studyPrograms={studyProgramDistribution} />
        <Row gutter={10} style={{ marginTop: "10px" }}>
          <Col span={14}>
            <Text strong>Linje</Text>
          </Col>
          <Col span={5}>
            <Text strong>Antall</Text>
          </Col>
          <Col span={5}>
            <Text strong>Andel</Text>
          </Col>
        </Row>
        <StyledHr />
        {studyProgramDistribution.map(({ studyProgram, amount }) => (
          <div key={studyProgram}>
            <Row gutter={10}>
              <Col span={14}>{studyProgram}</Col>
              <Col span={5}>{amount}</Col>
              <Col span={5}>{((amount / registeredStudents.length) * 100).toFixed(1)}%</Col>
            </Row>
            <StyledHr />
          </div>
        ))}
      </Card>
    </>
  );
};

export default StudyProgramDistribution;
